import React, { Component } from "react";

class Dashboard extends Component {
  render() {
    return <div />;
  }
}

export default Dashboard;
